import React from 'react';
import MainToolBar from '../../../HeaderWrapper/ToolBarWrapper/MainToolBar/MainToolBar';

const MobileHeaderButtons = () => {
  return <MainToolBar />;
};

export default MobileHeaderButtons;
